import i18n from '@/utils/i18n';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { FONTS } from '@/styles';
import { formatShortDate, formatTime, momentWithTimezone } from '@/utils/date';
import { PEPPER_SUPPORT_UUID } from '@/constants';
import { Text } from 'react-native';
import { useLayoutContext } from '@/contexts/layout-context';

interface Props {
  orderName?: string | null;
  placedAt?: string | null;
  placedBy?: {
    name: string;
    uuid: string;
  } | null;
}

export const OrderInfo: React.FC<Props> = ({
  orderName,
  placedAt,
  placedBy,
}) => {
  const [styles] = useStyles();
  const { isSmallLayout } = useLayoutContext();

  const placedAtMoment = momentWithTimezone(placedAt);
  const placedByPepper = placedBy?.uuid === PEPPER_SUPPORT_UUID;
  const placedByText =
    placedAt && placedBy && !placedByPepper
      ? i18n.t('placed_by_on_at', {
          date: formatShortDate(placedAtMoment),
          name: placedBy.name,
          time: formatTime(placedAtMoment),
        })
      : null;
  const orderNameText = orderName
    ? i18n.t('order_name', { name: orderName })
    : null;

  if (!placedByText && !orderNameText) {
    return null;
  }

  if (!isSmallLayout) {
    return (
      <Text numberOfLines={2} style={styles.text}>
        {[placedByText, orderNameText].filter(Boolean).join(' \u2022 ')}
      </Text>
    );
  }

  return (
    <>
      {placedByText ? (
        <Text numberOfLines={2} style={styles.text}>
          {placedByText}
        </Text>
      ) : null}
      {orderNameText ? (
        <Text
          numberOfLines={2}
          style={[styles.text, placedByText ? styles.subsequentLine : null]}
        >
          {orderNameText}
        </Text>
      ) : null}
    </>
  );
};

const useStyles = createStyles((theme) => ({
  subsequentLine: {
    marginTop: 0,
  },
  text: {
    ...FONTS.primary,
    color: theme.colors.primary,
    fontSize: 14,
    lineHeight: 18,
    marginTop: 8,
  },
}));
